module.exports = __webpack_public_path__ + "static/yarn-eb799db20d756181b75866b90a765e99.svg";